/**
 * Utility functions for Secret Field Plugin
 */

import { MAX_SECRET_CONTENT_LENGTH, ValidationResult } from './types';

/**
 * Validate secret field data
 */
export function validateSecretField(label: string, content: string): ValidationResult {
  // Label is now optional - no validation needed for empty label

  // Content length validation
  if (content.length > MAX_SECRET_CONTENT_LENGTH) {
    return {
      valid: false,
      error: `Content exceeds maximum length of ${MAX_SECRET_CONTENT_LENGTH} characters`,
    };
  }

  return { valid: true };
}

/**
 * Copy text to clipboard
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const result = document.execCommand('copy');
      document.body.removeChild(textArea);
      return result;
    }
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
}

/**
 * Generate unique ID for secret field
 */
export function generateSecretFieldId(): string {
  return `secret_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}



